import React from 'react'
import {connect} from "react-redux";
import {send_booster_cmd} from "../../etc/cmd";
import {MSG_BOOST_OFF, MSG_BOOST_ON} from "../BidibMessages";

const BoosterN = ({node}) => {
    const booster = node || {
        BIDIB_BST_DIAG_I: 0xFF,
        BIDIB_BST_DIAG_V: 0xFF,
        BIDIB_BST_DIAG_T: 0xFF,
        boost_stat: 0xFF}

    const booster_state = parseInt(booster.boost_stat)

    //let st = (booster_state < 0x80)?"off":"on";

    let current = booster.BIDIB_BST_DIAG_I || 0
    if (current < 64) {
        current = (current - 12) * 4
    } else if (current < 128) {
        current = (current - 51) * 16
    } else if (current < 192) {
        current = (current - 108) * 64
    } else if (current < 251) {
        current = (current - 171) * 256
    }
    const voltage = booster.BIDIB_BST_DIAG_V / 10.0
    const temperature = booster.BIDIB_BST_DIAG_T

    let offreason = ""
    switch(booster_state) {
        case 0x00:
            offreason = "off";
            break;
        case 0x01:
            offreason = "shortcut";
            break;
        case 0x02:
            offreason = "off and too hot";
            break;
        case 0x03:
            offreason = "has no mains";
            break;
        case 0x04:
            offreason = "off and local go request is present";
            break;
        case 0x05:
            offreason = "off (was turned off by a local key)";
            break;
        case 0x06:
            offreason = "Booster is off (no DCC input)";
            break;
        case 0x80:
            offreason = "on";
            break;
        case 0x81:
            offreason = "on and critical current flows";
            break;
        case 0x82:
            offreason = "on and is getting hot";
            break;
        case 0x83:
            offreason = "on and a local stop request is present";
            break;
        case 0x84:
            offreason = "on (was turned on by a local key)";
            break;
    }

    /*
BIDIB_BST_STATE_OFF           0x00  // Booster turned off
BIDIB_BST_STATE_OFF_SHORT     0x01  // Booster is off, output shortend
BIDIB_BST_STATE_OFF_HOT       0x02  // Booster off and too hot
BIDIB_BST_STATE_OFF_NOPOWER   0x03  // Booster has no mains
BIDIB_BST_STATE_OFF_GO_REQ    0x04  // Booster off and local go request is present
BIDIB_BST_STATE_OFF_HERE      0x05  // Booster off (was turned off by a local key)
BIDIB_BST_STATE_OFF_NO_DCC    0x06  // Booster is off (no DCC input)
BIDIB_BST_STATE_ON            0x80  // Booster on
BIDIB_BST_STATE_ON_LIMIT      0x81  // Booster on and critical current flows
BIDIB_BST_STATE_ON_HOT        0x82  // Booster on and is getting hot
BIDIB_BST_STATE_ON_STOP_REQ   0x83  // Booster on and a local stop request is present
BIDIB_BST_STATE_ON_HERE       0x84  // Booster on (was turned on by a local key)
     */

    function onBoosterClick() {
        let cc = {
            id: booster.uid,
            state: (booster_state < 0x80) ? MSG_BOOST_ON : MSG_BOOST_OFF,
        }
        send_booster_cmd(cc);
    }

    const boosterstyle = {
        color: 'black',
        backgroundColor: booster_state < 0x80 ? 'red' : 'rgb(151,175,109)',
        padding: 5,
        cursor: 'pointer',
    }

    return (
        <>
            <div title={'Booster ' + booster.uid + " (" + booster.product + ")"} key={booster.uid} style={boosterstyle}
                 onClick={onBoosterClick}
            >
                {current}mA&nbsp;
                {voltage}V&nbsp;
                {temperature}°C&nbsp;&nbsp;[{offreason}] | {booster_state}
            </div>
        < />);
}

function mapStateToProps(state, other) {
    return {node: state.bidib.data.node.find(it =>it.uid === other.boosterid)}
}

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(BoosterN)